import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PeopleHRAPIKeyServerSide } from '@app/models/integrations/people-hr/people-hr-api-key-server-side.model';
import { PeopleHRAPIKey } from '@app/models/integrations/people-hr/people-hr-api-key.model';
import { PeopleHRSyncTokenServerSide } from '@app/models/integrations/people-hr/people-hr-sync-token-server-side.model';
import { PeopleHRSyncToken } from '@app/models/integrations/people-hr/people-hr-sync-token.model';
import { PeopleHrUserServerSide } from '@app/models/integrations/people-hr/people-hr-user-server-side.model';
import { PeopleHrUser } from '@app/models/integrations/people-hr/people-hr-user.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PeopleHRAPIService {
  private readonly BASE_URL: string = 'api/people-hr';

  constructor(private http: HttpClient) { }

  getApiKey(): Observable<PeopleHRAPIKey | null> {
    const url = `${this.BASE_URL}/api-key`;
    return this.http.get<PeopleHRAPIKeyServerSide | null>(url).pipe(
      map(peopleHRAPIKey => peopleHRAPIKey === null ? null : new PeopleHRAPIKey(peopleHRAPIKey))
    );
  }

  addApiKey(key: string): Observable<PeopleHRAPIKey> {
    const url = `${this.BASE_URL}/api-key`;
    return this.http.post<PeopleHRAPIKeyServerSide>(url, key).pipe(map(peopleHRAPIKey => new PeopleHRAPIKey(peopleHRAPIKey)));
  }

  removeApiKey(): Observable<null> {
    const url = `${this.BASE_URL}/api-key`;
    return this.http.delete<null>(url);
  }

  getSyncToken(): Observable<PeopleHRSyncToken | null> {
    const url = `${this.BASE_URL}/sync-token`;
    return this.http.get<PeopleHRSyncTokenServerSide | null>(url).pipe(
      map(peopleHRSyncToken => peopleHRSyncToken === null ? null : new PeopleHRSyncToken(peopleHRSyncToken))
    );
  }

  enableSyncing(): Observable<PeopleHRSyncToken> {
    const url = `${this.BASE_URL}/sync-token`;
    return this.http.post<PeopleHRSyncTokenServerSide>(url, null).pipe(map(peopleHRSyncToken => new PeopleHRSyncToken(peopleHRSyncToken)));
  }

  disableSycning(): Observable<null> {
    const url = `${this.BASE_URL}/sync-token`;
    return this.http.delete<null>(url);
  }

  performSync(): Observable<null> {
    const url = `${this.BASE_URL}/sync`;
    return this.http.post<null>(url, null);
  }

  getAllPeopleHrUsers(): Observable<Array<PeopleHrUser>> {
    const url = `${this.BASE_URL}/user`
    return this.http.get<Array<PeopleHrUserServerSide>>(url).pipe(
      map(users => users.map(user => new PeopleHrUser(user)))
    );
  }

  getPeopleHrUserByUserId(userId: number): Observable<PeopleHrUser | null> {
    const url = `${this.BASE_URL}/user/${userId}`
    return this.http.get<PeopleHrUserServerSide | null>(url).pipe(
      map(u => (u === null ? null : new PeopleHrUser(u)))
    );
  }

}